<template>
  <div ref="domRef" :class="['base-card-info', 'min-h-[245px]', marginBottom ? 'mb-0' : '']">
    <div class="info-card-title">
      开户许可证信息
    </div>
    <div class="custom-base-info">
      <div class="item">
        <div class="label">
          {{ isPersonalCompany ? '法定代表人银行卡' : '银行开户许可证' }}
        </div>
        <div class="value h-[0]">
          <div v-if="!isPersonalCompany? baseInfo.companyLicense?.licenseUrl : baseInfo.companyLicense?.bankCardUrl" class="business-license-box">
            <img
              :src="!isPersonalCompany? baseInfo.companyLicense?.licenseUrl : baseInfo.companyLicense?.bankCardUrl"
            >
          </div>
          <div v-else class="business-license-box" />
        </div>
      </div>
      <div class="item">
        <div class="label">
          账户类型
        </div>
        <div class="value">
          {{ isPersonalCompany ? '法人银行卡' : '对公账户' }}
        </div>
      </div>
      <div v-if="!isPersonalCompany" class="item">
        <div class="label">
          对公账户名
        </div>
        <div class="value">
          {{ baseInfo.companyLicense?.accountName }}
        </div>
      </div>
      <div v-if="!isPersonalCompany" class="item">
        <div class="label" />
        <div class="value" />
      </div>
      <div v-if="!isPersonalCompany" class="item">
        <div class="label">
          纳税人识别号
        </div>
        <div class="value">
          {{ baseInfo.companyLicense?.creditCode }}
        </div>
      </div>
      <div v-if="!isPersonalCompany" class="item">
        <div class="label">
          开票地址
        </div>
        <div class="value">
          {{ baseInfo.companyLicense?.address }}
        </div>
      </div>
      <div v-if="!isPersonalCompany" class="item">
        <div class="label" />
        <div class="value" />
      </div>      
      <div v-if="!isPersonalCompany" class="item">
        <div class="label">
          银行预留手机号
        </div>
        <div class="value">
          {{ baseInfo.companyLicense?.phoneNo }}
        </div>
      </div>
      <div class="item">
        <div class="label">
          开户银行
        </div>
        <div class="value">
          {{ baseInfo.companyLicense?.bankName }}
        </div>
      </div>
      <div class="item">
        <div class="label" />
        <div class="value" />
      </div>
      <div class="item">
        <div class="label">
          银行账号
        </div>
        <div class="value">
          {{ isPersonalCompany ? baseInfo.companyLicense?.personBankAccount : baseInfo.companyLicense?.bankAccount }}
        </div>
      </div>
      <div v-if="isPersonalCompany" class="item">
        <div class="label">
          银行预留手机号
        </div>
        <div class="value">
          {{ baseInfo.companyLicense?.bankPhone }}
        </div>
      </div>
      <div v-if="!isPersonalCompany" class="item">
        <div class="label" />
        <div class="value" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useElementImgPreview } from '@vue3/components';
import { inject, ref, watch, Ref } from 'vue';
import { ICompanyMergeInfo } from '@core/main/types';
import { EBindingType } from '@core/main';

defineOptions({ name: 'BindingCardInfo' }); // 账户中心 - 开户许可证信息

const domRef = ref<HTMLDivElement>();

useElementImgPreview(domRef);

const baseInfo = inject<Ref<ICompanyMergeInfo>>('baseInfo');
const isPersonalCompany = ref(false);

defineProps({
  marginBottom: {
    type: Boolean,
    default: false,
  },
});

watch(
  () => baseInfo.value,
  (val) => {
    if (val) {
      isPersonalCompany.value = val.companyLicense?.licenseType === EBindingType.Personal;
    }
  },
  { immediate: true });
</script>
